import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { dirPageMeta, dirSchema } from 'components/common/schema'
import Template from 'components/cases/dir'

const Dir: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...dirPageMeta} />
      <JsonLd data={dirSchema} />
      <Template />
    </>
  )
}

export default Dir
